import { useDictionaryContext } from '3-foundation/Dictionary/DictionaryContext';
import { UI_OrganisationList } from 'ui/components/3-organisms/OrganisationList/OrganisationList';

export const OrganisationList = ({ content }: Content.OrganisationList) => {
	const { heading, link, organisations } = content ?? {};
	const dictionary = useDictionaryContext();

	return (
		<UI_OrganisationList
			heading={heading}
			link={{ url: link?.url, name: link?.name, target: link?.target }}
			items={organisations?.map((o) => {
				const phone = `${dictionary?.getContact('Phone')}: ${o.phone}`;
				const email = `${dictionary?.getContact('Email')}: ${o.email}`;
				return {
					logo: { ...o.logo, altText: '' },
					heading: o.name,
					text: o.address,
					phone,
					email,
					link: o.organisationPageLink,
				};
			})}
		/>
	);
};
